import * as service from "../service";
import { cloudinaryUploadList } from "../../middleware/uploadImage";
import {
  toEventFormBody,
  type EventDetails,
  type EventFormPayload,
} from "../user/events";
import type { ServiceResponse } from "../types";

/**
 * Update an existing event. The web port of the RN `UpdateEventAPI`.
 * Backend: POST /api/organizer/dashboard/editEvent
 *
 * Note: the backend edit route ignores `hash_tags`, so tag edits made here
 * are not persisted by the API — they are kept in the form for the create
 * flow only.
 */
export const UpdateEventAPI = async (
  eventId: string,
  payload: EventFormPayload,
): Promise<ServiceResponse<EventDetails>> => {
  try {
    const resp = await service.call("POST", "api/organizer/dashboard/editEvent", {
      id: eventId,
      ...toEventFormBody({
        ...payload,
        imageUrls: await cloudinaryUploadList(payload.imageUrls),
      }),
    });
    return resp;
  } catch (err) {
    console.error(`UpdateEventAPI ${err}`);
    return { status: -1 };
  }
};
